import { cn } from '../../lib/cn';
import type { ObservabilityRow } from '../../enterpriseintegration/framework';

type Props = { streams?: ObservabilityRow[] };

export function IntegrationObservabilityPanel({ streams = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {streams.map((s) => (
        <div key={s.signal} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{s.signal}</p>
          <p className="mt-1 text-lg font-semibold">{s.volume}</p>
          <span className={cn(
            'mt-1 inline-block text-xs font-medium',
            s.status === 'indexed' || s.status === 'scraped' || s.status === 'correlated'
              ? 'text-success-600' : 'text-brand-600',
          )}>
            {s.status}
          </span>
        </div>
      ))}
    </div>
  );
}
